module.exports = __webpack_public_path__ + "img/conceptia.c1774443.jpg";